/**
 * Per-App theme storage + build-time stack.
 *
 * Builders call `getActive*()` without an App argument. Wrapping each create/rebuild
 * in `runWith` makes the correct palette available on the stack (single-threaded JS),
 * while `WeakMap` keeps an App-scoped snapshot for lookups after build.
 */
export function createThemeScope(fallback) {
    var byApp = new WeakMap();
    var stack = [];
    var last = fallback();
    return {
        runWithResult: function (theme, fn) {
            stack.push(theme);
            try {
                return fn();
            }
            finally {
                stack.pop();
            }
        },
        getActive: function (app) {
            if (stack.length > 0)
                return stack[stack.length - 1];
            if (app && byApp.has(app))
                return byApp.get(app);
            return last;
        },
        sync: function (theme, app) {
            last = theme;
            if (app)
                byApp.set(app, theme);
            return theme;
        },
    };
}
